export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/service-ticket.e68afd75-e41f0c.png";